import * as React from "react"

const SvgColdSubscriber = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M2.5 17.2v.8q0 .825.587 1.412Q3.675 20 4.5 20h6a.97.97 0 0 0 .713-.288A.97.97 0 0 0 11.5 19a.97.97 0 0 0-.287-.713A.97.97 0 0 0 10.5 18h-6v-.8a.97.97 0 0 1 .5-.85q.9-.45 2.325-.9t3.2-.45a.96.96 0 0 0 .688-.275.9.9 0 0 0 .287-.675q0-.475-.287-.763a.94.94 0 0 0-.688-.287q-1.7 0-3.313.4A15 15 0 0 0 4.1 14.55q-.75.375-1.175 1.1T2.5 17.2" />
    <path
      fillRule="evenodd"
      d="M7.675 10.825Q8.85 12 10.5 12c1.65 0 2.042-.392 2.825-1.175Q14.5 9.649 14.5 8c0-1.649-.392-2.042-1.175-2.825Q12.15 4 10.5 4c-1.65 0-2.042.392-2.825 1.175Q6.5 6.35 6.5 8c0 1.65.392 2.041 1.175 2.825m4.237-1.413A1.93 1.93 0 0 1 10.5 10q-.825 0-1.412-.588A1.93 1.93 0 0 1 8.5 8q0-.825.588-1.413A1.93 1.93 0 0 1 10.5 6q.825 0 1.412.587.588.588.588 1.413c0 .825-.196 1.02-.588 1.412"
      clipRule="evenodd"
    />
    <path d="M17.5 10.17a.83.83 0 0 1 .83.83v.996l.583-.583a.83.83 0 0 1 1.174 1.174l-1.757 1.757v.826h.826l1.757-1.757a.83.83 0 0 1 1.174 1.174l-.583.583h.996a.83.83 0 1 1 0 1.66h-.996l.583.583a.83.83 0 1 1-1.174 1.174l-1.757-1.757h-.826v.826l1.757 1.757a.83.83 0 1 1-1.174 1.174l-.583-.583V21a.83.83 0 1 1-1.66 0v-.996l-.583.583a.83.83 0 0 1-1.174-1.174l1.757-1.757v-.826h-.826l-1.757 1.757a.83.83 0 0 1-1.174-1.174l.583-.583H12.5a.83.83 0 1 1 0-1.66h.996l-.583-.583a.83.83 0 0 1 1.174-1.174l1.757 1.757h.826v-.826l-1.757-1.757a.83.83 0 0 1 1.174-1.174l.583.583V11a.83.83 0 0 1 .83-.83" />
  </svg>
)
export default SvgColdSubscriber
